import React__default from 'react';
import { parseMergedHandlers, Controller } from '../../core/dist/use-gesture-core.esm.js';
import { r as registerAction, e as dragAction, f as pinchAction, s as scrollAction, w as wheelAction, m as moveAction, h as hoverAction } from '../../core/dist/actions-fe213e88.esm.js';
export { C as ConfigResolverMap, E as EngineMap } from '../../core/dist/actions-fe213e88.esm.js';

function useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
  const ctrl = React__default.useMemo(() => new Controller(handlers), []);
  ctrl.applyHandlers(handlers, nativeHandlers);
  ctrl.applyConfig(config, gestureKey);
  React__default.useEffect(ctrl.effect.bind(ctrl));
  React__default.useEffect(() => {
    return ctrl.clean.bind(ctrl);
  }, []);
  if (config.target === undefined) {
    return ctrl.bind.bind(ctrl);
  }
  return undefined;
}

function createUseGesture(actions) {
  actions.forEach(registerAction);
  return function useGesture(_handlers, _config) {
    const {
      handlers,
      nativeHandlers,
      config
    } = parseMergedHandlers(_handlers, _config || {});
    return useRecognizers(handlers, config, undefined, nativeHandlers);
  };
}

function useGesture(handlers, config) {
  const hook = createUseGesture([dragAction, pinchAction, scrollAction, wheelAction, moveAction, hoverAction]);
  return hook(handlers, config || {});
}

export { createUseGesture, dragAction, hoverAction, moveAction, pinchAction, registerAction, scrollAction, useGesture, wheelAction };
//# sourceMappingURL=use-gesture-react.esm.js.map
